import { __extends } from "tslib";
import { BitmapFilter } from './BitmapFilter';
import { NumberUtilities } from '@awayfl/swf-loader';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: BlurFilter
var BlurFilter = /** @class */ (function (_super) {
    __extends(BlurFilter, _super);
    function BlurFilter(blurX, blurY, quality) {
        if (blurX === void 0) { blurX = 4; }
        if (blurY === void 0) { blurY = 4; }
        if (quality === void 0) { quality = 1; }
        var _this = _super.call(this) || this;
        _this.blurX = blurX;
        _this.blurY = blurY;
        _this.quality = quality;
        return _this;
    }
    BlurFilter.FromUntyped = function (obj) {
        return new BlurFilter(obj.blurX, obj.blurY, obj.quality);
    };
    BlurFilter.prototype._updateFilterBounds = function (bounds) {
        BitmapFilter._updateBlurBounds(bounds, this._blurX, this._blurY, this._quality, true);
    };
    BlurFilter.prototype._serialize = function (message) {
        message.ensureAdditionalCapacity(16);
        message.writeIntUnsafe(1);
        message.writeFloatUnsafe(this._blurX);
        message.writeFloatUnsafe(this._blurY);
        message.writeIntUnsafe(this._quality);
    };
    Object.defineProperty(BlurFilter.prototype, "blurX", {
        get: function () {
            return this._blurX;
        },
        set: function (value) {
            this._blurX = NumberUtilities.clamp(+value, 0, 255);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlurFilter.prototype, "blurY", {
        get: function () {
            return this._blurY;
        },
        set: function (value) {
            this._blurY = NumberUtilities.clamp(+value, 0, 255);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlurFilter.prototype, "quality", {
        get: function () {
            return this._quality;
        },
        set: function (value /*int*/) {
            this._quality = NumberUtilities.clamp(value | 0, 0, 15);
        },
        enumerable: true,
        configurable: true
    });
    BlurFilter.prototype.clone = function () {
        return new BlurFilter(this._blurX, this._blurY, this._quality);
    };
    // Called whenever the class is initialized.
    BlurFilter.classInitializer = null;
    // List of static symbols to link.
    BlurFilter.classSymbols = null; // [];
    // List of instance symbols to link.
    BlurFilter.instanceSymbols = null;
    return BlurFilter;
}(BitmapFilter));
export { BlurFilter };
